var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentloanpayoffGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.36,121.79a9,9,0,0,1,.7-3.5,9.14,9.14,0,1,1-.7,3.5m-5.08,0a14.22,14.22,0,1,0,1.08-5.44,14.21,14.21,0,0,0-1.08,5.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.95 108.65 107.07 111.85 91.59 105.43 88.28 97.6 114.95 108.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.07 69.91 37.24 76.46 101.55 103.01 95 87.18 53.07 69.91",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.88,108.33a2,2,0,0,1-2,2H31.12a2,2,0,0,1-2-2V72.08a4.39,4.39,0,0,1,1.61-3.17l15.15-11a3,3,0,0,1,3.24,0l15.15,11a4.39,4.39,0,0,1,1.61,3.17Z",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.88,108.33a2,2,0,0,1-2,2H31.12a2,2,0,0,1-2-2V72.08a4.39,4.39,0,0,1,1.61-3.17l15.15-11a3,3,0,0,1,3.24,0l15.15,11a4.39,4.39,0,0,1,1.61,3.17Z",
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.48,92.39a6,6,0,1,0,8.13-5.64c-1.18-.38-3-.3-4.22-.76a6,6,0,1,1,8.13-5.64m-5.75-6.74V69.69m0,32.64V98.41",
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.68,33V44A83.09,83.09,0,0,0,80,64.89,85.5,85.5,0,0,0,37.32,44V33",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80 5 16.59 26.14 80 47.27 143.41 26.14 80 5",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "80 24.53 47.5 38.69 47.5 56.7",
    fill: "none",
    stroke: "#0af",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,23.15a1.5,1.5,0,1,1-.78,2A1.5,1.5,0,0,1,79.4,23.15Z",
    fill: "#0af"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52.78 120.4 36.95 113.84 101.26 87.3 94.71 103.12 52.78 120.4",
    fill: "#666",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07,68.53h0a9.16,9.16,0,1,1,.7,3.5,9.12,9.12,0,0,1-.7-3.5m-5.08,0a14.23,14.23,0,1,0,8.79-13.14A14.12,14.12,0,0,0,95,68.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.66 81.67 106.73 78.34 91.25 84.75 87.99 92.72 114.66 81.67"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentloanpayoffGoal);
export default __webpack_public_path__ + "static/media/studentloanpayoff-goal.f57d8a43.svg";
export { ForwardRef as ReactComponent };